import { useState } from 'react';
import InitFilters from './constants/InitFiltering';
import { useCurrencyUnit } from 'hooks';

const useCustomHook = () => {
  const currencyText = useCurrencyUnit();
  const [loading, setLoading] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState(InitFilters(currencyText));

  return {
    loading,
    setLoading,
    filters, setFilters,
    filterParams,
    setFilterParams,
    size, setSize,
    page, setPage

  };
};

export default useCustomHook;
